<form [formGroup]="rowTotaalFg">
    <div formArrayName="rowOpbrengsten">
        <div *ngFor="let row of rowOpbrengsten.controls; let i = index"
             [formGroupName]="i" class="row">
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving opbrengsten' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  id="bedragRow"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijRowOpbrengsten(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="trash"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="rowOpbrengsten.length === 0">
    <snelstart-ui-button (click)="addRijRowOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Opbrengsten invullen
    </snelstart-ui-button>
</div>
<div *ngIf="rowOpbrengsten.length > 0">
    <snelstart-ui-button (click)="addRijRowOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Opbrengsten toevoegen
    </snelstart-ui-button>
</div>

<form [formGroup]="rowTotaalFg">
    <div formArrayName="rowKosten">
        <div *ngFor="let row of rowKosten.controls; let i = index" [formGroupName]="i" class="row">
            <div *ngIf="rowKosten.length > 0" class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Bedrag' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijRowKosten(i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     class="col-auto"
                                     icon="trash"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
    <div *ngIf="rowKosten.length === 0">
        <snelstart-ui-button (click)="addRijRowKosten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="rowKosten.length > 0">
        <snelstart-ui-button (click)="addRijRowKosten()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Kosten toevoegen
        </snelstart-ui-button>
    </div>
</form>



